import React from 'react';
import Link from '../links/Link/Link';
import { useTranslation } from 'react-i18next';

function CardReadMore({ href, title, children }) {
  const { t } = useTranslation();

  function generateArialabel() {
    return title ? `${t('styleguide:link_to')} ${title}` : undefined;
  }

  return (
    <Link className="card__read-more" href={href} title={title} aria-label={generateArialabel()}>
      {children || t('styleguide:read_more')}
    </Link>
  );
}

export default CardReadMore;
